import { Money, Text, TextSizes } from '@afterpaytouch/core'
import { useFlag } from '../../../hooks'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent, useEffect } from 'react'
import styles from './style.module.scss'
import { ButtonDisplay } from './ButtonDisplay'
import { Money as IMoney, SupportedLocale } from '@afterpay/types'
import { useAmplitudeWithEnduringEventProperties } from '../../../integrations/amplitude'
import { TrackingEvent } from '../../../model/amplitude'

const I18N_NAMESPACE = ['common', 'index']

interface HeaderInfoDisplayProps {
  amount: IMoney
  amountSize: TextSizes
  locale: SupportedLocale
  isCreditLimit?: boolean
  isOwedAmount?: boolean
  isGbRegFlow?: boolean
}

export const HeaderInfoDisplay: FunctionComponent<HeaderInfoDisplayProps> = ({
  amount,
  amountSize,
  locale,
  isCreditLimit = false,
  isOwedAmount = false,
  isGbRegFlow = false,
}) => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const isConsumerLendingEnabled = useFlag('consumer-portal-header-lending-enabled', false)
  const { logEvent } = useAmplitudeWithEnduringEventProperties()
  const containerTestNameSpace = 'header-info-display'
  const amountTestNameSpace = `${containerTestNameSpace}${isCreditLimit ? '-credit-limit-money' : isOwedAmount ? '-total-owed-money' : ''}`
  const context = isCreditLimit ? 'estAvailable' : isOwedAmount ? 'totalOwing' : ''

  useEffect(() => {
    logEvent(TrackingEvent.VIEWED_HEADER_INFO_ON_HOME_PAGE, {
      isCreditLimit,
      isOwedAmount,
    })
  }, [])
  return (
    <div className={styles.container} data-testid={containerTestNameSpace}>
      <Text renderAs='span' size={amountSize} bold testNameSpace={amountTestNameSpace}>
        {Money({
          ...amount,
          locale,
        })}
      </Text>
      {!isConsumerLendingEnabled ? (
        <ButtonDisplay isCreditLimit={isCreditLimit} isOwedAmount={isOwedAmount} isGbRegFlow={isGbRegFlow} />
      ) : (
        <div className='flex sm:pb-2 md:pb-0'>
          <Text size={'S'}>{t(`index:welcome:existingUser:label:${context}`)}</Text>
        </div>
      )}
    </div>
  )
}
